import userMutations from './user'

export default {
    ...userMutations,
}


// WEBPACK FOOTER //
// ./src/vuex/mutations/index.js